// extracted by mini-css-extract-plugin
export var article = "ArticleViewerSection-module--article--b41ef";
export var capitalize = "ArticleViewerSection-module--capitalize--fad4c";
export var fs14 = "ArticleViewerSection-module--fs-14--b5c27";
export var fs16 = "ArticleViewerSection-module--fs-16--868eb";
export var fs20 = "ArticleViewerSection-module--fs-20--cb863";
export var fs24 = "ArticleViewerSection-module--fs-24--2b2de";
export var fs32 = "ArticleViewerSection-module--fs-32--3e49a";
export var fs40 = "ArticleViewerSection-module--fs-40--0fa2e";
export var fsItalic = "ArticleViewerSection-module--fs-italic--f8692";
export var fsLg = "ArticleViewerSection-module--fs-lg--512e1";
export var fsMd = "ArticleViewerSection-module--fs-md--1abd5";
export var fsNormal = "ArticleViewerSection-module--fs-normal--d2f08";
export var fsSm = "ArticleViewerSection-module--fs-sm--3cc13";
export var fsXl = "ArticleViewerSection-module--fs-xl--b55ca";
export var fsXs = "ArticleViewerSection-module--fs-xs--66943";
export var fsXxl = "ArticleViewerSection-module--fs-xxl--4f468";
export var fsXxs = "ArticleViewerSection-module--fs-xxs--84740";
export var fwBold = "ArticleViewerSection-module--fw-bold--cbe82";
export var fwMedium = "ArticleViewerSection-module--fw-medium--d5401";
export var fwNormal = "ArticleViewerSection-module--fw-normal--e9c48";
export var gotham_bold = "ArticleViewerSection-module--gotham_bold--a9933";
export var gotham_bold_italic = "ArticleViewerSection-module--gotham_bold_italic--86f39";
export var gotham_book = "ArticleViewerSection-module--gotham_book--5d74c";
export var gotham_book_italic = "ArticleViewerSection-module--gotham_book_italic--a0adb";
export var gridContainer = "ArticleViewerSection-module--gridContainer--6e306";
export var lowercase = "ArticleViewerSection-module--lowercase--a2c53";
export var navigation = "ArticleViewerSection-module--navigation--2e5af";
export var template = "ArticleViewerSection-module--template--78916";
export var uppercase = "ArticleViewerSection-module--uppercase--53e1e";